import { render } from "./ScreenLocked.vue?vue&type=template&id=588354ad&scoped=true"
import script from "./ScreenLocked.vue?vue&type=script&lang=js"
export * from "./ScreenLocked.vue?vue&type=script&lang=js"

import "./ScreenLocked.vue?vue&type=style&index=0&id=588354ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588354ad"]])

export default __exports__